const CHAVE = 'data'

export const gravarDados = (dados) => {
  sessionStorage.setItem(CHAVE,JSON.stringify(dados));
}

export const obterDados = () =>  JSON.parse(sessionStorage.getItem(CHAVE));

export const logout = () => sessionStorage.clear();